<template>
  <v-layout column>
    <v-layout v-show="noAttrs">
      -
    </v-layout>
    <v-layout
      v-for="(k, i) in attrsKeys"
      :key="`attr-${i}`"
      class="py-1"
    >
      <strong class="mr-1">
        {{ k }}:
      </strong>
      <template v-if="k === 'foldingType' && getFoldingType(items[k])">
        {{ getFoldingType(items[k]) }}
      </template>
      <template v-else-if="k === 'envelopeOrderItem'">
        {{ getProductTypeByOrderItemId(items[k]) }}
      </template>
      <template v-else-if="k === 'csvUrl'">
        <a
          :href="items[k]"
          class="info--text"
          target="_blank"
        >
          {{ items[k] }}
        </a>
      </template>
      <template v-else>
        {{ formatItem(items[k]) }}
      </template>
    </v-layout>
    <a
      v-show="!noAttrs && Object.keys(items).length > 1"
      class="blue--text"
      @click="showAll = !showAll"
    >
      Show {{ showAll ? 'less' : 'more' }}
    </a>
  </v-layout>
</template>

<script>
export default {
  name: 'KernelOrderItemAttributesView',
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
    orderItems: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({ showAll: false }),
  computed: {
    items() {
      const excluded = ['clientInvoice'];
      const items = {
        ...(this.item.attributes || {}),
        ...(this.item.foldingAttributes || {}),
        ...(this.item.bookletAttributes || {}),
        ...(this.item.mailingAttributes || {}),
        ...(this.item.notepadAttributes || {}),
        stuffing: (this.item.holidayCardAttributes || {}).stuffing,
      };

      return Object.keys(items).reduce((acc, k) => {
        const v = items[k];

        if (v !== null && v !== undefined && !excluded.includes(k)) {
          acc[k] = v;
        }

        return acc;
      }, {});
    },
    noAttrs() {
      return !Object.keys(this.items).length;
    },
    attrsKeys() {
      const keys = Object.keys(this.items);
      return this.showAll ? keys : keys.slice(0, 1);
    },
  },
  methods: {
    formatItem(item) {
      if (typeof item === 'boolean') {
        return item ? 'yes' : 'no';
      }
      return item;
    },
    getFoldingType(item) {
      const types = {
        F6_4: 'tri-fold',
        'F6-4': 'tri-fold',
        F6_1: 'z-fold',
        'F6-1': 'z-fold',
        F6_2: 'z-fold',
        'F6-2': 'z-fold',
        F4_1: 'bi-fold',
        'F4-1': 'bi-fold',
      };

      return types[item] || item;
    },
    getProductTypeByOrderItemId(id) {
      return this.orderItems.find(({ outerId }) => outerId === id)?.productType ?? '';
    },
  },
};
</script>
